import React from 'react'
import PropTypes from 'prop-types'
import { ImageWrapper } from './style'

const Loader = ({ style = {} }) => {
  return (
    <ImageWrapper style={style} />
  )
}

Loader.propTypes = {
  style: PropTypes.object
}

export default Loader
